import {request, _urlPromoCodes} from "../api";
import {PROMO_CODES_CONSTS, UTIL_CONSTS} from "../constants";
import swal from "sweetalert";
import {LIMIT_GET_PROMO_CODES} from "../../constants/constLimitCounts";
import {history} from "../../configs/history";
import {notificationSuccess} from "../../components/uiElements/Notifications";

export const GetPromoCodes = ({
                                  reset = true,
                                  offset = 0,
                                  userId = null,
                                  status = null,
                                  text = null,
                                  limit = LIMIT_GET_PROMO_CODES,
                              } = {}) => {
    let url = `${_urlPromoCodes}?offset=${offset}&limit=${limit}`;
    status && (url += `&status=${status}`);
    userId && (url += `&userId=${userId}`);
    text && (url += `&text=${text}`);
    const requestData = {
        url,
        token: true,
        method: "GET",
    };

    return dispatch => {
        reset && dispatch({type: UTIL_CONSTS.START_LOADING});
        return request(requestData)
            .then(({data}) => {
                data && dispatch({
                    type: PROMO_CODES_CONSTS.GET_PROMO_CODES,
                    payload: {
                        data: data,
                        status,
                        userId,
                        reset,
                        hasMore: data.length === limit
                    }
                });
                return data
            }).finally(() => {
                dispatch({
                    type: UTIL_CONSTS.END_LOADING
                })
            })
    }
};

export const AddPromoCode = (data) => {
    const requestData = {
        url: _urlPromoCodes,
        token: true,
        method: "POST",
        data,
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                notificationSuccess({
                    description: "Զեղչի կոդը հաջողությամբ ստեղծվեց!"
                })
                history.push('/promoCodes')
            })
    }
};

export const DeletePromoCode = (id) => {
    const requestData = {
        url: `${_urlPromoCodes}/${id}`,
        token: true,
        method: "DELETE",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: PROMO_CODES_CONSTS.DELETE_PROMO_CODE,
                    payload: id
                });
                notificationSuccess({
                    description: "Զեղչի կոդը հաջողությամբ ջնջվեց!"
                })
            })
    }
};
